<template>
  <!-- BEGIN Overlay Search Results, This part is for demo purpose, you can add anything you like !-->
  <div class="container-fluid">
    <!--<span>
          <strong>suggestions :</strong>
      </span>
    <span id="overlay-suggestions"></span>
    <br>-->
    <div class="search-results m-t-40">
      <!--<p class="bold">Pages Search Results</p>-->
      <div class="row">
        <div class="col-md-12">
          <!-- START PANEL -->
          <div class="panel panel-transparent">
            <div class="panel-body">
              <div class="table-responsive">
                <table class="table table-hover table-condensed table-detailed table-striped search-table" id="detailedTable">
                  <thead>
                    <tr>
                        <th></th>
                        <th>Société
                            <a v-if="this.sortByCorporation"
                            @click="this.sortByCorporationName"
                            title="Trier par ordre alphabétique ascendant."
                            >
                                <i class="fa fa-sort-alpha-asc"></i>
                            </a>
                            <a v-else
                                @click="this.sortByCorporationName"
                                title="Trier par ordre alphabétique descendant."
                            >
                                <i class="fa fa-sort-alpha-desc"></i>
                            </a>
                        </th>
                        <th>Nom
                        <a v-if="this.sortByRepresentative"
                        @click="this.sortByRepresentativeName"
                            title="Trier par ordre alphabétique ascendant."
                        >
                            <i class="fa fa-sort-alpha-asc"></i>
                        </a>
                        <a v-else
                            @click="this.sortByRepresentativeName"
                            title="Trier par ordre alphabétique descendant."
                        >
                            <i class="fa fa-sort-alpha-desc"></i>
                        </a>
                        </th>
                        <th>Contrat
                        </th>
                        <th>Options</th>
                        <th>Détails</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(customer, index) in customers">
                      <item @click="onItemClick(index)" :key="customer.id" :customer="customer"
                            :show-details="idxItemDetails === index" :has-details="hasDetails(customer)">
                      </item>
                      <item-details v-if="idxItemDetails === index" :customer="customer" :key="index">
                      </item-details>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!-- END PANEL -->
        </div>
      </div>
    </div>
  </div>
  <!-- END Overlay Search Results !-->
</template>

<style lang="scss" scoped>
  .panel-body {
    min-width: 600px;
  }
  .search-table {
    th {
      width: auto;
      &:first-child {
        width: 40px;
      }
      &:nth-child(5) {
        width: 110px;
      }
      &:last-child {
        width: 113px;
      }
    }
  }
</style>


<script type="text/babel">
  import Item from './Item'
  import ItemDetails from './ItemDetails'

  export default {
    props: ['customers'],

    components: {
      Item,
      ItemDetails
    },

    data () {
      return {
        idxItemDetails: null,
        sortByCorporation: true,
        sortByContract : false,
        sortByRepresentative: true,
      }
    },

    methods: {
      onItemClick (idx) {
        this.idxItemDetails = (this.idxItemDetails !== idx) ? idx : null
      },

      hasDetails (customer) {
        return _.filter(
                customer.contracts,
                contract => contract.type === "domiciliation_contract"
        ).length
      },

      sortByCorporationName () {
        this.$parent.set_order('name', this.sortByCorporation ? 'desc' : 'asc')
        this.sortByCorporation = !this.sortByCorporation
        this.sortByRepresentative = true
      },

      sortByContractType () {
        // Sort here the customer's array
        this.customers = this.customers.sort ( (a, b) =>
        {
          var tmp_a = 0;
          var tmp_b = 0;
          for (var a_contract in a.contracts) {
            if (a_contract.type === "domiciliation_contract")
              tmp_a += 1
          }
          for (var b_contract in b.contracts) {
            if (b_contract.type === "domiciliation_contract")
              tmp_b += 1
          }
          if (tmp_a == tmp_b)
            return 0
          else if (this.sortByContract)
          {
            if (tmp_b > tmp_a)
              return -1
            else
              return 1
          }
          else
          {
            if (tmp_b > tmp_a)
              return 1
            else
              return -1
          }})
        this.sortByContract = !this.sortByContract
      },

      sortByRepresentativeName () {
        this.$parent.set_order('main_representative.name', this.sortByRepresentative ? 'desc' : 'asc')
        this.sortByRepresentative = !this.sortByRepresentative
        this.sortByCorporation = true
      },
    },

    watch: {
      customers: function(newValue, oldValue) {
        this.idxItemDetails = null
      }
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/SearchOverlay/Results.vue